import axiosInstance from "../axiosInstance";

export const PUTPaletRoyalCaninASA = async (idauds, cb1, cb2, cb3) => {
  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_WMS_BASE_URL}/auditoria/palet/royal-canin`,
      null,
      {
        params: {
          idauds,
          cb1,
          cb2,
          cb3,
        },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default PUTPaletRoyalCaninASA;
